module.exports = __webpack_public_path__ + "static/media/icon_yinsibaohu.c58eaff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_yinsibaohu.svg
// module id = 122
// module chunks = 0